import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=cinematic%20dark%20theater%20interior%20with%20glowing%20screen%20and%20red%20velvet%20seats%20dramatic%20atmospheric%20lighting%20warm%20golden%20accents%20against%20deep%20shadow%20luxury%20cinema%20hall%20empty%20but%20grand%20architectural%20perspective%20high%20contrast%20editorial%20photography&width=1920&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="91高清视频 - 在线影院"
        title="91高清视频在线观看 - 畅享高清视界"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/40 to-background-50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4">
        <div className="text-center max-w-3xl">
          <div className="inline-flex items-center gap-2 bg-primary-500/15 backdrop-blur-sm rounded-full px-4 py-1.5 mb-6">
            <div className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></div>
            <span className="text-primary-500 text-sm font-medium">每日更新 · 高清画质</span>
          </div>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-foreground-950 leading-tight mb-4">
            {t('hero.title')}
          </h1>
          <p className="text-foreground-500 text-base md:text-lg mb-8 max-w-xl mx-auto">
            {t('hero.subtitle')}
          </p>
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-foreground-950 font-semibold px-8 py-3.5 rounded-full text-base transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-play-circle-line text-xl"></i>
            {t('hero.cta')}
          </Link>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent pointer-events-none"></div>
    </section>
  );
}